import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import LabelFont from '../../../Theme/Fonts/Label'

type Props = {
    count: number | string
}

const Counter: FunctionComponent<Props> = ({ count }): ReactElement => {
    return (
        <Grid noExpand marginX={2}>
            <LabelFont numberOfLines={1} color="keshi-3">
                {count.toString()}
            </LabelFont>
        </Grid>
    )
}

export default Counter
